<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h1 i18n>Available bookings</h1>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
    </mat-card-content>
</mat-card>
